module.exports = __webpack_public_path__ + "img/entertainment.68e7079.svg";